import { TranslationKeys } from '../index';

export const es: TranslationKeys = {
  betBuilder: {
    title: 'Constructor de Apuestas',
    noBetsSelected: 'El Constructor de Apuestas está vacío',
    addSelections: 'Añadir selecciones',
    totalOdds: 'Cuotas Totales',
    totalSelections: 'Total de Selecciones',
    clearAll: 'Limpiar Todo',
    removeBet: 'Eliminar apuesta',
    addBet: 'Añadir apuesta',
    event: 'Evento',
    market: 'Mercado',
    selection: 'Selección',
    odds: 'Cuotas',
    confirmClear: 'Limpiar Todas las Apuestas',
    confirmClearMessage: '¿Estás seguro de que quieres eliminar todas las apuestas? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    confirm: 'Limpiar Todo',
    closed: 'Cerrado',
    suspend: 'Suspender',
    eventClosed: 'Evento Cerrado',
    eventSuspended: 'Evento Suspendido',
    buildABet:''
  },
  betStatus: {
    won: 'Ganada',
    pending: 'Pendiente',
    refund: 'Reembolso',
    lost: 'Perdida',
    halfwon: 'Media Ganada',
    halflost: 'Media Perdida',
    cashout: 'Retiro',
    unknown: 'Desconocido'
  },
  common: {
    loading: 'Cargando...',
    error: 'Error',
    retry: 'Reintentar',
    close: 'Cerrar',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    settings: 'Configuración'
  },
  errors: {
    generic: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    network: 'Error de red. Por favor, verifica tu conexión.',
    notFound: 'El recurso solicitado no fue encontrado.',
    unauthorized: 'No estás autorizado para realizar esta acción.',
    validation: 'Por favor, verifica tu entrada e inténtalo de nuevo.'
  }
};